import {
    ColumnFactory,
    ComponentManager,
    LabelViewModel,
    Utilities,
} from 'radpresentation.htmlclient.defaultviewextensions';
class ExtensionManagerTextColumnFactory extends ColumnFactory {
    private default: string;
    private isDynamic: boolean;
    private visibleObs: KnockoutObservable<boolean>;
    private isValidObs: KnockoutObservable<boolean>;
    private $div: JQuery;
    private tooltip: string;

    static isPlainText = false;
    static isJQueryElement = true;

    constructor(params: any) {
        super(params);

        this.isDynamic = params.isDynamic;
        this.visibleObs = params.visibleObs;
        this.default = params.default;
        this.tooltip = params.tooltip;

        this.isValidObs = params.isValidObs;

        if (this.visibleObs) {
            this.defineComputed(() => {
                let isVisible = this.visibleObs();
                if (this.$div) {
                    this.$div[isVisible ? 'removeClass' : 'addClass'](
                        'staticProperty'
                    );
                }
            });
        }

        if (this.isValidObs) {
            this.defineComputed(() => {
                let isValid = this.isValidObs();
                if (this.$div) {
                    this.$div[isValid ? 'removeClass' : 'addClass']('invalid');
                    this.$div
                        .closest('td')
                        [isValid ? 'removeClass' : 'addClass']('invalid');
                }
            });
        }
    }

    public getValue(): any {
        if (this.$div) {
            return this.$div;
        }

        let $div = $('<div>' + this.raw + '</div>');

        if (
            (this.visibleObs && !this.visibleObs()) ||
            (!this.visibleObs && !this.isDynamic)
        ) {
            $div.addClass('staticProperty');
        }

        if (this.isValidObs && !this.isValidObs()) {
            $div.addClass('invalid');
        }

        if (Utilities.isNotBlank(this.tooltip)) {
            ko.applyBindingsToNode($div[0], {
                tooltip: new LabelViewModel({ caption: this.tooltip }),
            });
        }

        this.$div = $div;
        return $div;
    }
}

export default ExtensionManagerTextColumnFactory;
ComponentManager.setFactory(
    'ExtensionManagerTextColumnFactory',
    ExtensionManagerTextColumnFactory,
    'RADExtensionManagerHTMLViewExtension'
);
ComponentManager.setFactory(
    'ExtensionManagerTextColumn',
    ExtensionManagerTextColumnFactory,
    'RADExtensionManagerHTMLViewExtension'
);
